import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "./Header";
import VertNav from "./VertNav";
import AddProductPopup from "./AddProductPopup";
import DeleteProductPopup from "./DeleteProductPopup";
import EditProductPopup from "./EditProductPopup";
import config from "../../config";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Category from "./InventoryCategory";

function Inventory() {
  const [isAddPopupOpen, setIsAddPopupOpen] = useState(false);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [editProductData, setEditProductData] = useState(null);
  const [inventoryData, setInventoryData] = useState([]);
  const [deleteProductData, setDeleteProductData] = useState(null);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isAddPopupOpen2, setIsAddPopupOpen2] = useState(false);
  const [activeTab, setActiveTab] = useState("inventory");
  const [utilizedData, setUtilizedData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [newUsage, setNewUsage] = useState({
    product: "",
    category: "",
    staff: "",
    product_quantity: "",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const AddUsage = () => setIsModalOpen(true);

  const handleClose = () => setIsModalOpen(false);

  const bid = localStorage.getItem("branch_id");
  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token");
  const userType = user.type;
  const AddtogglePopup = () => setIsAddPopupOpen(!isAddPopupOpen);
  const AddtogglePopup2 = () => setIsAddPopupOpen2((prev) => !prev);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [deleteCategoryModal, setDeleteCategoryModal] = useState({
    isOpen: false,
    category: null,
  });
  const EdittogglePopup = (product) => {
    setEditProductData(product);
    setIsEditPopupOpen(!isEditPopupOpen);
  };

  const handleDeleteClick = (item) => {
    setDeleteProductData(item);
    setIsConfirmDialogOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewUsage((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "category" ? { product: "" } : {}), // Reset product if category changes
    }));
  };

  const handleConfirmDelete = async () => {
    const token = localStorage.getItem("token");
    const productId = deleteProductData.id;

    if (!productId) return;

    try {
      const response = await fetch(
        `${config.apiUrl}/api/swalook/inventory/product/?id=${productId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        setInventoryData(
          inventoryData.filter((item) => item.product_id !== productId),
        );
        window.location.reload();
      }
    } catch (error) {
      console.error(`Error deleting product:`, error);
    }
    setIsConfirmDialogOpen(false);
  };

  const handleCancelDelete = () => setIsConfirmDialogOpen(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${config.apiUrl}/api/swalook/product_category/?branch_name=${bid}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setCategories(data.data); // Store the complete category objects
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    const fetchInventory = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${config.apiUrl}/api/swalook/inventory/product/?branch_name=${bid}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setInventoryData(data.data);
      } catch (error) {
        console.error("Error fetching inventory data:", error);
      }
    };

    fetchCategories();
    fetchInventory();
  }, [bid]);

  // Group by category for the dropdown
  const groupedInventory = inventoryData.reduce((acc, item) => {
    const category = item.category_details?.product_category || "Uncategorized";
    if (!acc[category]) acc[category] = [];
    acc[category].push(item);
    return acc;
  }, {});

  const fetchStaffData = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token is missing.");
        return;
      }

      const response = await fetch(
        `${config.apiUrl}/api/swalook/staff/?branch_name=${bid}`,
        {
          method: "GET",
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        console.error(`API Error: ${response.status} - ${response.statusText}`);
        return;
      }

      const data = await response.json();
      const staffArray = Array.isArray(data.table_data) ? data.table_data : [];

      const formattedOptions = staffArray.map((staff) => ({
        label: staff.staff_name,
        value: staff.staff_name,
      }));

      setStaffData(formattedOptions);
    } catch (error) {
      console.error("Error fetching staff data:", error);
      setStaffData([]);
    }
  };

  const handleSubmit = async () => {
    try {
      //       const selectedCategory = Object.keys(groupedInventory).find(
      //   cat => cat === newUsage.category
      // );

      const selectedCategory = inventoryData.find(
        (item) => item.category_details?.product_category === newUsage.category,
      )?.category_details?.id;

      console.log("Selected category search results:", {
        searchFor: newUsage.category,
        foundItem: inventoryData.find(
          (item) =>
            item.category_details?.product_category === newUsage.category,
        ),
        extractedId: selectedCategory,
      });
      const submissionData = {
        ...newUsage,
        created_at: new Date().toISOString().split("T")[0],
        category: selectedCategory, // Add category ID from the product
      };

      const response = await fetch(
        `${config.apiUrl}/api/swalook/inventory/utilizationinventory/?branch_name=${bid}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
          body: JSON.stringify(submissionData),
        },
      );

      if (response.ok) {
        // Refresh your data or update state
        fetchUtilizedData();
        setIsModalOpen(false);
        // Reset form if needed
        setNewUsage({
          category: "",
          product: "",
          staff: "",
          product_quantity: "",
        });
      } else {
        console.error("Submission failed");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const fetchUtilizedData = async () => {
    try {
      const response = await fetch(
        `${config.apiUrl}/api/swalook/inventory/utilizationinventory/?branch_name=${bid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        },
      );
      if (!response.ok) {
        throw new Error("Failed to fetch utilization data");
      }
      const data = await response.json();
      console.log("data", data);
      setUtilizedData(data.data);
    } catch (error) {
      console.error("Error fetching utilization data:", error);
      // Optionally show error to user
    }
  };

  useEffect(() => {
    fetchUtilizedData();
  }, []);

  const handleDeleteCategory = (category) => {
    setDeleteCategoryModal({
      isOpen: true,
      category,
    });
  };
  const confirmCategoryDelete = async () => {
    const { category } = deleteCategoryModal;
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${config.apiUrl}/api/swalook/product_category/?branch_name=${bid}&id=${category.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        // Refresh the categories list
        const updatedCategories = categories.filter(
          (cat) => cat.id !== category.id,
        );
        setCategories(updatedCategories);

        // If the deleted category was selected, clear the selection
        if (selectedCategory && selectedCategory.id === category.id) {
          setSelectedCategory(null);
        }
      } else {
        console.error("Failed to delete category");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
    } finally {
      setDeleteCategoryModal({ isOpen: false, category: null });
    }
  };

  const cancelCategoryDelete = () => {
    setDeleteCategoryModal({ isOpen: false, category: null });
  };

  return (
    <>
      <Helmet>
        <title>Inventory</title>
      </Helmet>
      <Header />
      <VertNav />

      <div className="p-4 md:p-8  min-h-screen">
        <div className="flex justify-center space-x-4 mb-6 ml-0 md:ml-[19rem]">
          <button
            onClick={() => setActiveTab("inventory")}
            className={`px-6 py-2 rounded-lg ${
              activeTab === "inventory"
                ? "bg-blue-500 text-white"
                : "bg-transparent border-indigo-500 border-2 text-blue-500 font-bold"
            }`}
          >
            Inventory
          </button>
          <button
            onClick={() => setActiveTab("utilization")}
            className={`px-6 py-2 rounded-lg ${
              activeTab === "utilization"
                ? "bg-blue-500 text-white"
                : "bg-transparent border-indigo-500 border-2 text-blue-500 font-bold"
            }`}
          >
            Utilization
          </button>
        </div>
        {activeTab === "inventory" ? (
          <>
            <div className="flex flex-wrap justify-between items-center my-6 ml-0 md:ml-[19rem]">
              <h1 className="text-2xl font-bold">Inventory Details</h1>
              <div className="flex space-x-4">
                <button
                  className="bg-blue-500 text-white items-center mb-4 my-6 px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  onClick={AddtogglePopup2}
                >
                  Add Category
                </button>
                <button
                  onClick={AddtogglePopup}
                  className="bg-blue-500 text-white items-center mb-4 my-6 px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  Add
                </button>
              </div>
            </div>

            <div className="ml-0 md:ml-[19rem]">
              <div className="flex flex-wrap gap-2 mb-4">
                <div className="flex flex-wrap gap-2 mb-4">
                  <div className="flex flex-wrap gap-2 mb-4">
                    {categories.map((category) => (
                      <div key={category.id} className="flex items-center">
                        <button
                          onClick={() =>
                            setSelectedCategory(category.product_category)
                          }
                          className={`px-4 py-2 rounded-l-lg font-medium text-sm focus:outline-none 
          ${
            selectedCategory === category.product_category
              ? "bg-blue-500 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
                        >
                          {category.product_category}
                        </button>
                        <button
                          onClick={() => handleDeleteCategory(category)}
                          className={`px-2 py-2 rounded-r-lg font-medium text-sm focus:outline-none 
          ${
            selectedCategory === category.product_category
              ? "bg-red-500 text-white"
              : "bg-gray-300 text-gray-700 hover:bg-gray-400"
          }`}
                        >
                          <DeleteIcon fontSize="small" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Products Table for Selected Category */}
              <div className="overflow-x-auto">
                {selectedCategory ? (
                  groupedInventory[selectedCategory]?.length > 0 ? (
                    <table className="min-w-full bg-white rounded-lg">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="py-2 px-4 border">S.No</th>
                          <th className="py-2 px-4 border">Name</th>
                          <th className="py-2 px-4 border">SKU</th>
                          <th className="py-2 px-4 border">Quantity</th>
                          <th className="py-2 px-4 border">Pack Size</th>
                          <th className="py-2 px-4 border">Price</th>
                          <th className="py-2 px-4 border">Expiry Date</th>
                          <th className="py-2 px-4 border">Edit</th>
                          <th className="py-2 px-4 border">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {groupedInventory[selectedCategory].map(
                          (item, index) => (
                            <tr
                              key={item.product_id}
                              className="hover:bg-gray-100"
                            >
                              <td className="py-2 px-4 text-center border">
                                {index + 1}
                              </td>
                              <td className="py-2 px-4 text-center border">
                                {item.product_name}
                              </td>
                              <td className="py-2 px-4 text-center border">
                                {item.product_id}
                              </td>
                              <td className="py-2 px-4 text-center border ">
                                {item.stocks_in_hand}
                              </td>
                              <td className="py-2 px-4 text-center border">
                                {item.pack_size}
                              </td>
                              <td className="py-2 px-4 text-center border">
                                ₹{item.product_price}
                              </td>
                              <td className="py-2 px-4 text-center border">
                                {item.expiry_date}
                              </td>
                              <td className="py-2 px-4 text-center border">
                                <EditIcon
                                  onClick={() =>
                                    EdittogglePopup({
                                      ...item,
                                      category_id: item.category_details?.id,
                                    })
                                  }
                                  className="text-blue-500 cursor-pointer"
                                />
                              </td>
                              <td className="py-2 px-4 text-center border">
                                {userType === "staff" ? (
                                  <DeleteIcon className="text-gray-400 opacity-50 cursor-not-allowed" />
                                ) : (
                                  <DeleteIcon
                                    onClick={() => handleDeleteClick(item)}
                                    className="text-red-500 cursor-pointer"
                                  />
                                )}
                              </td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <div className="text-center py-4 text-gray-500">
                      No products available in this category
                    </div>
                  )
                ) : (
                  <div className="text-center py-4 text-gray-500">
                    Please select a category
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-wrap justify-between items-center my-16 ml-0 md:ml-[19rem]">
              <h1 className="text-2xl font-bold">Utilized Inventory</h1>
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
                onClick={AddUsage}
              >
                + Add Usage
              </button>
            </div>

            <div className="overflow-x-auto ml-0 md:ml-[19rem]">
              <table className="min-w-full bg-white rounded-lg-b-lg ">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="py-2 px-4 border">S.No.</th>
                    <th className="py-2 px-4 border">Created At</th>
                    <th className="py-2 px-4 border">Category</th>
                    <th className="py-2 px-4 border">Inventory Item</th>
                    <th className="py-2 px-4 border">Employee</th>
                    <th className="py-2 px-4 border">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {utilizedData.length > 0 ? (
                    utilizedData.map((entry, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="py-2 px-4 border text-center">
                          {index + 1}
                        </td>
                        <td className="py-2 px-4 border text-center">
                          {" "}
                          {entry.created_at.split("-").reverse().join("-")}
                        </td>
                        <td className="py-2 px-4 border text-center">
                          {entry.category}
                        </td>
                        <td className="py-2 px-4 border text-center">
                          {entry.product}
                        </td>
                        <td className="py-2 px-4 border text-center">
                          {entry.staff}
                        </td>
                        <td className="py-2 px-4 border text-center">
                          {entry.product_quantity}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className="text-center text-gray-500 py-4 border"
                      >
                        No usage records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg-md w-[90%] max-w-md relative">
              <h2 className="text-xl font-bold mb-4">Add Usage</h2>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium">
                    Select Category
                  </label>
                  <select
                    name="category"
                    value={newUsage.category}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 border-blue-500  focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Select Category</option>
                    {Object.keys(groupedInventory).map((category) => (
                      <option key={category} value={category}>
                        {category}
                      </option>
                    ))}
                  </select>
                </div>

                {newUsage.category && (
                  <div>
                    <label className="block text-sm font-medium">
                      Select Product
                    </label>
                    <select
                      name="product"
                      value={newUsage.product}
                      onChange={handleChange}
                      className="w-full border rounded-lg px-3 py-2  border-blue-500 focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="">Select Product</option>
                      {groupedInventory[newUsage.category]?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {" "}
                          {/* Changed to use product_id */}
                          {item.product_name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div>
                  <label className="block text-sm font-medium">Employee</label>
                  <select
                    name="staff"
                    value={newUsage.staff}
                    onChange={handleChange}
                    onClick={fetchStaffData} // fetch only when dropdown is clicked
                    className="w-full border rounded-lg px-3 py-2 border-blue-500 focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Select Employee</option>
                    {staffData.map((staff, index) => (
                      <option key={index} value={staff.value}>
                        {staff.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium">Quantity</label>
                  <input
                    type="number"
                    name="product_quantity"
                    value={newUsage.product_quantity}
                    onChange={handleChange}
                    min="0.001"
                    step="any"
                    className="w-full border rounded-lg px-3 py-2 border-blue-500 focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                {/* <div>
          <label className="block text-sm font-medium">Created At</label>
          <input
            type="date"
            name="createdAt"
            value={newUsage.createdAt}
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2 border-blue-500 focus:ring-2 focus:ring-blue-500"
          />
        </div> */}
              </div>

              <div className="mt-6 flex justify-end space-x-3">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    handleSubmit();
                    setIsModalOpen(false);
                  }}
                  className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Delete Category Confirmation Modal */}
        {deleteCategoryModal.isOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg max-w-md w-full">
              <h3 className="text-lg font-bold mb-4">Confirm Deletion</h3>
              <p className="mb-6">
                Are you sure you want to delete the category "
                {deleteCategoryModal.category?.product_category}"? This action
                cannot be undone.{" "}
                <span className="font-semibold">
                  All the products under this category will also be deleted
                </span>
              </p>
              <div className="flex justify-end space-x-3">
                <button
                  onClick={cancelCategoryDelete}
                  className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmCategoryDelete}
                  className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {isAddPopupOpen && <AddProductPopup onClose={AddtogglePopup} />}
        {isAddPopupOpen2 && <Category onClose={AddtogglePopup2} />}
        {isEditPopupOpen && (
          <EditProductPopup
            productData={editProductData}
            onClose={EdittogglePopup}
          />
        )}
        {isConfirmDialogOpen && (
          <DeleteProductPopup
            title="Confirm Deletion"
            message={`Are you sure you want to delete the product "${deleteProductData?.product_name}"?`}
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
          />
        )}
      </div>
    </>
  );
}

export default Inventory;
